import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class StudentCommonValidation {

	static AdminEducationValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.trim();

			if (!value) {
				return null;
			}

			if (value.length < 2) {
				return { minLengthEducation: true };
			}

			if (value.length > 100) {
				return { maxLengthEducation: true };
			}

			const regex = /^[A-Za-z0-9\s.,()]+$/;

			if (!regex.test(value)) {
				return { invalidEducation: true };
			}

			return null;
		};
	}


	static AdminCgpaValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;

			if (value === null || value === undefined || value === '') {
				return null;
			}

			const stringValue = value.toString().trim();

			if (!/^\d+(\.\d{1,2})?$/.test(stringValue)) {
				return { invalidCgpa: true };
			}

			const cgpa = parseFloat(stringValue);

			if (cgpa < 0 || cgpa > 10) {
				return { cgpaRange: true };
			}

			return null;
		};
	}

	static AdminSkillsValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.trim();

			if (!value) {
				return null;
			}

			const skills = value.split(',').map((skill: string) => skill.trim());

			if (skills.some((skill: string) => !skill)) {
				return { emptySkill: true };
			}

			if (skills.length > 20) {
				return { maxSkills: true };
			}

			if (skills.some((skill: string) => skill.length > 40)) {
				return { invalidSkills: true };
			}

			const uniqueSkills = new Set(
				skills.map((skill: string) => skill.toLowerCase())
			);

			if (uniqueSkills.size !== skills.length) {
				return { duplicateSkills: true };
			}

			return null;
		};
	}

	static AdminCandidateSkillsValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.trim();

			if (!value) {
				return null;
			}

			const skills = value.split(',').map((skill: string) => skill.trim());

			if (skills.some((skill: any) => skill === '')) {
				return { emptySkill: true };
			}

			if (skills.length > 30) {
				return { maxSkills: true };
			}

			const regex = /^[A-Za-z0-9\s+#&()./-]+$/;

			for (const skill of skills) {

				if (skill.length < 2) {
					return { minSkillLength: true };
				}

				if (skill.length > 50) {
					return { maxSkillLength: true };
				}

				if (!regex.test(skill)) {
					return { invalidSkills: true };
				}
			}

			const uniqueSkills = new Set(
				skills.map((skill: any) => skill.toLowerCase())
			);

			if (uniqueSkills.size !== skills.length) {
				return { duplicateSkills: true };
			}

			return null;
		};
	}


	static AdminCandidateCgpaValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;

			if (value === null || value === undefined || value.toString().trim() === '') {
				return null; // Optional field
			}

			const stringValue = value.toString().trim();

			// Only numbers with up to 2 decimal places
			if (!/^(10(\.0{1,2})?|[0-9](\.\d{1,2})?)$/.test(stringValue)) {
				return { invalidCgpa: true };
			}

			const cgpa = parseFloat(stringValue);

			// Range: 0.00 - 10.00
			if (cgpa < 0 || cgpa > 10) {
				return { cgpaRange: true };
			}

			return null;
		};
	}

	static AdminYearOfPassingValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.toString().trim();

			if (!value) {
				return null;
			}

			// Only 4 digits
			if (!/^\d{4}$/.test(value)) {
				return { invalidYear: true };
			}

			const year = Number(value);
			const currentYear = new Date().getFullYear();

			if (year < 1950) {
				return { minYear: true };
			}

			if (year > currentYear) {
				return { futureYear: true };
			}

			return null;
		};
	}


	static CompanyCandidateNameValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.trim();

			if (!value) {
				return null;
			}

			if (value.length < 2) {
				return { minLengthCompany: true };
			}

			if (value.length >= 100) {
				return { maxLengthCompany: true };
			}

			const companyRegex = /^[A-Za-z0-9\s\-./&]+$/;

			if (!companyRegex.test(value)) {
				return { invalidCompany: true };
			}

			return null;
		};
	}

	static JobCandidateTitleValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.trim();

			if (!value) {
				return null;
			}

			if (value.length < 2) {
				return { minLengthJobTitle: true };
			}

			if (value.length >= 100) {
				return { maxLengthJobTitle: true };
			}

			const jobTitleRegex = /^[A-Za-z0-9\s\-./&]+$/;

			if (!jobTitleRegex.test(value)) {
				return { invalidJobTitle: true };
			}

			return null;
		};
	}
}